<template>
  <div class="uploadImg">
    <div class="updataimgs">
      <i
          :class="showText ? 'iconTop' : ''"
          class="el-icon-plus icons"
          @click="initupeles"
      ></i>
    </div>
    <input
        class="inputfiles"
        type="file"
        ref="inputfile"
        :disabled="onlyView"
        hidden
        @change="upLoad"
        id="addimgfiles"
        :accept="filetype"
    />
  </div>
</template>

<script>
import { uploadFile } from "@/server/api.js";
export default {
  name: "UploadImg",
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
    onlyView: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    filetype: {
      type: String,
      default: "",
    },
    uploadtype: {
      type: String,
      default: "image",
    },
    size: {
      type: Number,
      default: 10,
    },
    filelength: {
      type: Number,
      default: 0,
    },
    uploadListLen: {
      type: Number,
    },
  },
  data(){
    return{
      bosObj: "",
      time: "",
      uploader: null,
      fileList: this.fileupload ? this.fileupload : [],
      acceptType: {
        image: ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"],
        video: ["mp4","mov","wmv","rmvb","m4v","avi"],
        file: [
          "doc",
          "docx",
          "pdf",
          "xls",
          "xlsx",
          "txt",
          "ppt",
          "pptx",
          "rar",
          "html",
          "htm",
        ],
      },
    }
  },
  methods:{
    //替换字符串中的所有特殊字符（包含空格）
    trimSpecial(string){
      if (string != "") {
        const pattern = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
        pattern.lastIndex = 0;
        // console.log(string.match(pattern))
        return pattern.test(string);
      }
    },
    initupeles(){
      this.$refs.inputfile.click();
    },
    upLoad(e){
      if (this.filelength >= 9) return this.$notify({type:"warning",message:'最多上传9个'});
      let file = e.target.files[0];
      let size = parseFloat((file.size / 1024 / 1024).toFixed(2));
      let extension = file.name.slice(file.name.lastIndexOf(".") + 1);
      console.log(file.name);
      // let lastIndex = file.name.lastIndexOf('.');
      // if(this.trimSpecial(file.name.slice(0,lastIndex))){
      //   return this.$notify({type:"warning",message:'文件名不允许带有特殊字符或空格'});
      // }
      if (size > this.size) {
        return this.$notify({type:"warning",message:"大小不允许超过" + this.size + "MB"});
      }

      if (this.acceptType[this.uploadtype].indexOf(extension.toLowerCase()) === -1) {
        return this.$notify({type:"warning",message:'请上传正确格式的文件'});
      }

      if (this.uploadListLen >= 10) {
        return this.$notify({type:"warning",message:'最多上传10条内容'});
      }
      // console.log(extension, state.acceptType[prop.uploadtype], prop.size);
      let formdata = new FormData();
      formdata.append("filrName", file);
      uploadFile(formdata).then((res) => {
        this.$refs.inputfile.value = '';
        this.$emit('uploadInfo',{
          ...res.data,
          msgType: this.uploadtype || "",
          fileName: file.name,
          size:file.size
        })
      });
    }

  },
};
</script>

<style lang="less" scoped>
.uploadImg {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.updataimgs {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  .icons {
    font-size: 24px;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .iconTop {
    top: -12px;
  }
  .center-text {
    font-size: 12px;
    color: #999999;
    position: absolute;
    bottom: 14px;
  }
  .inputfiles {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
  }
  .inputimgs {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .clear-icon {
    position: absolute;
    z-index: 5;
    top: -12px;
    right: -12px;
    font-size: 23px;
    color: #e4393c;
    background: #fff;
    border-radius: 1000%;
    cursor: pointer;
  }
}
.inputfilesp {
  height: 0;
  width: 0;
  overflow: hidden;
}
</style>

